import React from "react";
import './CommonButton.css';

const CommonButton = (props) => {
    return (
        <>
            {
                props.isDisableApply
                    ?
                    <button
                        onClick={props.onclick}
                        style={{
                            padding: props.padding,
                            color: props.color,
                            backgroundColor: props.bgColor,
                            borderRadius: props.radius,
                            border: props.border,
                            lineHeight: props.lineheight,
                            marginLeft: props.ml,
                            cursor: !props.disabled ? "no-drop" : "pointer",
                            width: props.width,
                            textAlign: "center",
                            justifyContent: 'center',
                            fontSize: props.fontSize && props.fontSize
                        }}
                        className="customButton"
                        disabled={!props.disabled}
                    >
                        {props.title}
                    </button>
                    :
                    <button
                        onClick={props.onclick}
                        style={{
                            cursor:"pointer",
                            padding: props.padding,
                            color: props.color,
                            backgroundColor: props.bgColor,
                            borderRadius: props.radius,
                            border: props.border,
                            lineHeight: props.lineheight,
                            marginLeft: props.ml,
                            width: props.width,
                            textAlign: "center",
                            fontSize: 14,
                            fontWeight: 600
                        }}
                        className="customButton"
                    >
                        {props.title}
                    </button>
            }
        </>
    );
}

export default CommonButton;